/**
 * <SEO> — the only way a page should touch <head>.
 * @file src/web/shared/SEO.tsx
 *
 * Renders nothing. It exists so a page can declare its tags where it declares
 * everything else, rather than calling a hook at the top and leaving the
 * reader to notice. Every prop is forwarded to useSEO, which is where the
 * defaults and the reasoning live.
 *
 * @llm-rule WHEN: Every routed page, as the first child
 * @llm-rule AVOID: Setting document.title directly — you lose the canonical,
 *   the Open Graph card and the Twitter card, silently
 */

import type { FC } from 'react';
import { useSEO, type SEOOptions } from './hooks/useSEO';

export const SEO: FC<SEOOptions> = (props) => {
  useSEO(props);
  return null;
};

export default SEO;
